import React, { Fragment, useEffect, useRef, useState } from "react";
import { renderMarkdown } from '../utils/renderMarkdown';
import { linkHost } from '../utils/linkHost';
import VideoJS from './VideoJS';
import MediaCarousel from './MediaCarousel';
import PostLoveModal from 'react-bootstrap/Modal';
import { ADD_REPLY, POST_FETCH_COMMENT_ADDON, DELETE_REPLY, DELETE_COMMENT, DELETE_POST } from "../Reducer/postReducer";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import API from "../Network/API";
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";
import PostShareModal from "./PostShareModal";
import UserList from "./UserList";
import { useDispatch } from "react-redux";
import { SINGLE_DELETE_COMMENT, SINGLE_POST_ADD_REPLY, SINGLE_POST_DELETE_REPLY, SINGLE_POST_FETCH_COMMENT_ADDON } from "../Reducer/singlePostReducer";
import { FPOST_FETCH_COMMENT_ADDON } from "../Reducer/friendProfileReducer";
import { ReactComponent as LoveIcon } from "../assets/svg/love.svg";
import { ReactComponent as LoveFillIcon } from "../assets/svg/love_fill.svg";
import { ReactComponent as CommentsIcon } from "../assets/svg/comments.svg";
import { ReactComponent as ShareIcon } from "../assets/svg/share.svg";
import VerifiedBadge from "./VerifiedBadge";
import { useTranslation } from "react-i18next";
// toast.configure() removed — ToastContainer is mounted globally in App.js

export default function PostNew(props) {
    const { t } = useTranslation()
    const data = props?.data;
    const [showMore, setShowMore] = useState(false);
    const myArr = JSON.parse(localStorage.getItem('user_data'));
    const [love_react, setLoveReact] = useState(false);
    const [unlove_react, setUnLoveReact] = useState(false);
    const [isLiked, setIsLiked] = useState(!!data.is_like);
    const [likeCount, setLikeCount] = useState(parseInt(data.totalLikes, 10) || 0);
    // Prevents the WebSocket self-broadcast from overwriting an in-flight optimistic update
    const likeInflight = useRef(false);
    const [comment_love_react, setCommentLoveReact] = useState(false);
    const [reply_comment_delete, setReplyCommentDelete] = useState(false);
    const [reply_comment_id, setReplyCommentID] = useState(false);
    const [comment_love_react_add, setCommentLoveReactAdd] = useState(0);
    const [delete_post, setDeletePost] = useState(false);
    const [write_comment, setWriteComment] = useState('');
    const [reply_comment, setReplyComment] = useState('');
    const [share_comment, setShareComment] = useState(null);
    const [p_id_comment, setPIDComment] = useState(null);
    const [p_id_like, setPIDLike] = useState(0);
    const [p_id_com, setPIDCom] = useState(0);
    const [set_like, setLike] = useState(0);
    const [last_comments, setLastComments] = useState([]);
    const [set_comment, setComment] = useState(0);
    const [add_reply_comment, setAddReplyComment1] = useState(0);
    const [postId, setPostId] = useState(0);
    const [modalDialog, setModalDialog] = useState(false);
    const [modalDialogLoved, setModalDialogLoved] = useState(false);
    const [post_modalDialog, setPostShareModalDialog] = useState(false);
    const [commentSort, setCommentSort] = useState('newest');
    const [show, setShow] = useState(false);
    const [show_comment_box, setShowCommentBox] = useState(false);
    const [category_id, setCategoryId] = useState(0);
    const [report_note, setReportNote] = useState(0);
    const [categories, setCategories] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [is_comment_loading, setCommentLoading] = useState(false);
    const [reply_com_id, setReplyComID] = useState(0);
    const [comment_id, setCommentID] = useState(0);
    const [is_com_delete, setISComDelete] = useState(false);
    const [loadPostLove, setLoadPostLove] = useState(false);
    const [post_loved, setPostLoved] = useState([]);
    const [comment_page, setCommentPage] = useState(2);
    const [next_page_url, setNextPageURL] = useState(null);
    const [postView_modalDialog, setPostViewModalDialog] = useState(false);
    const [image_index, setImageIndex] = useState(null);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [showReplyEmojiPicker, setShowReplyEmojiPicker] = useState(false);
    const [expandedComments, setExpandedComments] = useState({});
    const [doubleTapHeart, setDoubleTapHeart] = useState(null);
    const [isHovered, setIsHovered] = useState(false);
    // Comment image state
    const [comment_image, setCommentImage] = useState(null);
    const [comment_image_preview, setCommentImagePreview] = useState(null);
    const [reply_image, setReplyImage] = useState(null);
    const [reply_image_preview, setReplyImagePreview] = useState(null);
    // Per-comment optimistic like tracking { [commentId]: { liked: bool, count: number } }
    const [commentLikes, setCommentLikes] = useState({});
    const [fullscreenImg, setFullscreenImg] = useState(null);
    const commentInputRef = useRef(null);
    const commentFileRef = useRef(null);
    const replyFileRef = useRef(null);
    const dispatch = useDispatch();
    const videoRef = React.useRef(null);

    const EMOJI_LIST = ['😀', '😂', '😍', '🥰', '😎', '🤔', '😢', '😡', '👍', '👎', '❤️', '🔥', '🎉', '💯', '🙏', '👏', '💪', '✨', '😮', '😅', '🤣', '😇', '🥺', '😤', '🤝', '💕', '😘', '🙄', '😴', '🤯', '💀', '👀', '🫡', '🤩', '😋'];

    const insertEmoji = (emoji, target) => {
        if (target === 'comment') {
            setWriteComment((prev) => (prev || '') + emoji);
            setShowEmojiPicker(false);
        } else {
            setReplyComment((prev) => (prev || '') + emoji);
            setShowReplyEmojiPicker(false);
        }
    };

    const toggleCommentExpand = (commentId) => {
        setExpandedComments(prev => ({ ...prev, [commentId]: !prev[commentId] }));
    };

    const handleCommentKeyDown = (e, submitFn) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            submitFn();
        }
    };

    const handleDoubleTap = (post_id) => {
        if (!isLiked) {
            postLike(post_id);
        }
        setDoubleTapHeart(post_id);
        setTimeout(() => setDoubleTapHeart(null), 900);
    };

    // Keyboard shortcuts: L = like, C = focus comment
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!isHovered) return;
            const tag = e.target.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA' || e.target.isContentEditable) return;

            if (e.key === 'l' || e.key === 'L') {
                e.preventDefault();
                if (isLiked) {
                    postUnLike(data.id);
                } else {
                    postLike(data.id);
                }
            }
            if (e.key === 'c' || e.key === 'C') {
                e.preventDefault();
                if (!show_comment_box) setShowCommentBox(true);
                setTimeout(() => commentInputRef.current?.focus(), 100);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isHovered, isLiked, show_comment_box]);

    const toggleModal = () => {
        setModalDialog(!modalDialog)
    };

    // Sync love state from Redux (WebSocket-driven) — but not while an API call is in-flight
    useEffect(() => {
        if (likeInflight.current) return;
        setIsLiked(!!data.is_like);
        setLikeCount(parseInt(data.totalLikes, 10) || 0);
    }, [data.id, data.totalLikes, data.is_like]);


    const toggleModalLoved = () => {
        setModalDialogLoved(!modalDialogLoved)
    };

    const toggleModalSharePost = () => {
        setPostShareModalDialog(!post_modalDialog)

    };

    const togglePostViewModalDialog = (imageIndex) => {
        setPostViewModalDialog(!postView_modalDialog)
        setImageIndex(imageIndex)
        props.get_post_data(data);
        props.get_post_image_index(imageIndex);
        props.togglePostView(!postView_modalDialog);
    };

    // handle mouse enter
    const handleMouseEnter = () => {
        if (videoRef.current) {
            videoRef.current.play();
        }
    };
    // handle mouse leave
    const handleMouseLeave = () => {
        if (videoRef.current) {
            videoRef.current.pause();
        }
    };

    useEffect(() => {
        // Reset pagination state when post changes
        setLastComments([]);
        setNextPageURL(null);
        setCommentPage(2);
    }, [data.id]);


    function fetchPostCommentNext(postId) {

        setCommentLoading(true)

        API.get('post_comment_history/?page=' + comment_page + '&post=' + postId + '&sort=' + commentSort, {
            'offset': last_comments.length
        }).then((response) => {
            setCommentLoading(false)
            const paginator = response.data.data;
            if (paginator.get_posts.length) {
                setLastComments([...last_comments, ...paginator.get_posts])
                setNextPageURL(paginator.next_page_url)
                setCommentPage((comment_page + 1))
            }
        }).catch((error) => {
            setCommentLoading(false)
        });

    }

    function handleSortChange(postId, newSort) {
        setCommentSort(newSort);
        setCommentPage(1);
        setCommentLoading(true);
        API.get('post_comment_history/?page=1&post=' + postId + '&sort=' + newSort)
            .then((response) => {
                setCommentLoading(false);
                const paginator = response.data.data;
                setLastComments(paginator.get_posts);
                setNextPageURL(paginator.next_page_url);
                setCommentPage(2);
            }).catch(() => setCommentLoading(false));
    }




    const postLike = (post_id) => {
        if (isLiked || likeInflight.current) return;
        likeInflight.current = true;
        setIsLiked(true);
        setLikeCount(prev => prev + 1);
        setPIDLike(post_id);
        API.post("v2/post_likes", {
            post_id: post_id,
            react_icon: 1,
        }).then((response) => {
            if (response.data.success !== true) {
                setIsLiked(false);
                setLikeCount(prev => prev - 1);
            }
        }).catch(() => {
            setIsLiked(false);
            setLikeCount(prev => prev - 1);
        }).finally(() => {
            likeInflight.current = false;
        });
    }

    const postUnLike = (post_id) => {
        if (!isLiked || likeInflight.current) return;
        likeInflight.current = true;
        setIsLiked(false);
        setLikeCount(prev => prev - 1);
        setPIDLike(post_id);
        API.post("v1/post_unlike", {
            post_id: post_id,
            react_icon: 1,
        }).then((response) => {
            if (response.data.success !== true) {
                setIsLiked(true);
                setLikeCount(prev => prev + 1);
            }
        }).catch(() => {
            setIsLiked(true);
            setLikeCount(prev => prev + 1);
        }).finally(() => {
            likeInflight.current = false;
        });
    }

    const toggleReply = (com_id) => {
        setShow(!show)
        setPIDCom(com_id)
    };

    const toggleComment = (post_id) => {
        setShowCommentBox(!show_comment_box)
        setPostId(post_id)
    };


    const commentLike = (post_id, comment_id, currentLiked, currentCount) => {
        // Optimistic toggle
        const newLiked = !currentLiked;
        const newCount = newLiked ? (currentCount || 0) + 1 : Math.max(0, (currentCount || 0) - 1);
        setCommentLikes(prev => ({ ...prev, [comment_id]: { liked: newLiked, count: newCount } }));

        if (newLiked) {
            API.post('comment_like', { post_id, comment_id, react_icon: 1 })
                .catch(() => {
                    // Revert on error
                    setCommentLikes(prev => ({ ...prev, [comment_id]: { liked: currentLiked, count: currentCount } }));
                });
        } else {
            API.delete('comment_unlike/' + comment_id)
                .catch(() => {
                    setCommentLikes(prev => ({ ...prev, [comment_id]: { liked: currentLiked, count: currentCount } }));
                });
        }
    }

    const commentsReplyDelete = (post_id, comment_id, comment_reply_id) => {
        setLoading(true)
        API.delete("/reply_comment_delete/" + comment_reply_id).then((response) => {
            if (response.data.success === true) {
                const payload = {
                    post_id: post_id,
                    comment_id: comment_id,
                    comment_reply_id: comment_reply_id,
                }
                setLoading(true)
                // setReplyCommentDelete(true)
                // setReplyCommentID(comment_reply_id)
                dispatch(DELETE_REPLY(payload))
                dispatch(SINGLE_POST_DELETE_REPLY(payload))

                toast.success('Comment deleted');
            }
        });
    }


    const handleReplyMessage = (p_id, cm_id) => {
        if (!reply_comment?.trim() && !reply_image) return;
        setLoading(true);
        setReplyComID(cm_id);
        const fd = new FormData();
        fd.append('post_id', p_id);
        fd.append('comment_id', cm_id);
        fd.append('comment', reply_comment || '');
        if (reply_image) fd.append('image', reply_image);
        // Do NOT set Content-Type manually — axios auto-sets multipart/form-data with boundary when given FormData
        API.post('comment_reply', fd)
            .then((response) => {
                setLoading(false);
                setReplyComment('');
                setReplyImage(null);
                setReplyImagePreview(null);
                if (response.data.success === true) {
                    dispatch(ADD_REPLY(response.data.data));
                    dispatch(SINGLE_POST_ADD_REPLY(response.data.data));
                }
            })
            .catch(() => setLoading(false));
    }

    const isMessageEmpty = write_comment.trim() === '' && !comment_image;
    const isReplyCommentEmpty = reply_comment.trim() === '' && !reply_image;

    const submit_comment = (p_id) => {
        if (!write_comment?.trim() && !comment_image) {
            toast.error('Empty comment');
            return false;
        }
        setLoading(true);
        const fd = new FormData();
        fd.append('post_id', p_id);
        fd.append('comment', write_comment || '');
        if (comment_image) fd.append('image', comment_image);
        // Do NOT set Content-Type manually — axios auto-sets multipart/form-data with boundary when given FormData
        API.post('post_comments', fd)
            .then((response) => {
                setLoading(false);
                setWriteComment('');
                setCommentImage(null);
                setCommentImagePreview(null);
                if (response.data.success === true) {
                    dispatch(POST_FETCH_COMMENT_ADDON(response.data.data));
                    dispatch(FPOST_FETCH_COMMENT_ADDON(response.data.data));
                    dispatch(SINGLE_POST_FETCH_COMMENT_ADDON(response.data.data));
                    setPostId(p_id);
                }
            })
            .catch(() => setLoading(false));
    }

    const postDelete = (post_id) => {
        setLoading(true)
        API.delete("/posts/" + post_id).then((response) => {
            if (response.data.success === true) {
                setLoading(false)
                setDeletePost(true)
                setPIDLike(post_id)
                dispatch(DELETE_POST(post_id))
                toast.success('Post deleted');
            }
        });
    }

    const get_post_report = (post_id) => {
        toggleModal();
        API.get('post_report/' + post_id)
            .then((response) => {
                setCategories(response.data.data.categories)
                toggleModal();
            }).catch((error) => {
            });
    }

    const save_post = (p_id) => {
        setLoading(true)
        API.post("/save_friend_post", {
            post_id: p_id,
        }).then((response) => {
            setLoading(false)
            if (response.data.success === true) {
                toast.success('Post Saved');
            }
        });
    }

    const commentsDelete = (comments_id, post_id) => {
        setLoading(true)
        API.delete("/comment_delete/" + comments_id).then((response) => {
            setLoading(false)
            if (response.data.success === true) {
                setISComDelete(true)
                setCommentID(comments_id)
                const comPayLod = {
                    comment_id: comments_id,
                    post_id: post_id,
                }
                dispatch(DELETE_COMMENT(comPayLod))
                dispatch(SINGLE_DELETE_COMMENT(comPayLod))
                setPostId(post_id)
                setComment(-1)
                toast.success('Comment deleted');
            }
        });
    }

    const share_post = (p_id) => {
        setPostId(p_id);
        toggleModalSharePost()
    }

    const send_report = (post_id) => {
        setLoading(true);
        API.post("/save_report", {
            post_id: post_id,
            category_id: parseInt(category_id),
            note: report_note,
        }).then((response) => {
            setLoading(false);
            if (response.data.success === true) {
                toast.success('Post reported');
                toggleModal();
            }
        }).catch((error) => {
            setLoading(false);
            toggleModal();
        });
    }

    const images =
        data.images?.length > 0 ?
            data.images.map((getImage, i) => (
                {
                    original: getImage.image,
                    thumbnail: getImage.image,
                }
            )) : "";

    let optionItems = categories?.map(category =>
        <option key={category.id} value={category.id}>{category.name}</option>
    );

    const love_report = (post_id) => {
        setLoadPostLove(true);
        API.get('post_love_details/' + post_id)
            .then((response) => {
                setPostLoved(response.data.data.data)
                toggleModalLoved();
            }).catch((error) => {
            });
    }

    return (

        <Fragment>
            <div key={data.id} className={`news-feed news-feed-post bg-white shadow-sm mb-3 ${p_id_like === data.id && delete_post ? 'd-none' : ''}`}
                onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                {
                    data.post_type == 1 ?
                        <div className="Promoted_Post_content mb-3">
                            <i class="far fa-lightbulb"></i>
                            <span class="ms-1">{t('Suggested')}</span>
                        </div>
                        : data.post_type == 2 ?
                            <div className="friend-rec-post mb-3">
                                <div className="post-header d-flex justify-content-between align-items-center mb-0">
                                    <div className="d-flex align-items-center">
                                        <div className="image">
                                            <Link to={`/contact/${data.suggest_user_id}`}>
                                                <div
                                                    className="user-picture-container rounded-circle"
                                                    style={{ backgroundImage: `url(${data.suggest_user_image})` }}
                                                />
                                            </Link>
                                        </div>
                                        <div className="info ms-2">
                                            <span className="name">
                                                <Link to={`/contact/${data.suggest_user_id}`}>{data.suggest_user_name}</Link>
                                            </span>
                                            <span className="rection ms-1">{t('reacted on this')}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            : data.post_type == 3 ?
                                <div className="Promoted_Post_content mb-3">
                                    <i class="fa fa-bolt"></i>
                                    <span class="ms-1">{t('Promoted')}</span>
                                </div>
                                :
                                ""
                }
                <div className="post-header d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                        <div className="image">
                            <Link to={`/contact/${data.user_id}`} className="avatar-with-presence">
                                <div className="user-picture-container rounded-circle"
                                    style={{ backgroundImage: `url(${data.avatar})` }} />
                                {data.is_online ? <span className="avatar-online-dot" title="Online" /> : ''}
                            </Link>
                        </div>
                        <div className="info ms-2">
                            <span className="name">
                                <Link to={`/contact/${data.user_id}`}>{data.post_by}
                                    <VerifiedBadge verified={data.is_verified} />
                                </Link>
                                {data.is_shared_post ?
                                    <span className=""><small className="fw-100 text-grey"> {t('shared')} </small> <Link to={`/contact/${data.root_user_id}`}>{data.root_user_name}</Link> <Link to={`/post/${data.share_post_id}`}><span className="fw-700 text-grey-900">{t('Post')}</span></Link></span> : ""}

                            </span>
                            <span className="small-text"><a href="javascript:void(0)">{data.post_time}</a></span>
                        </div>
                    </div>

                    <div className="dropdown">
                        <button className="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false"><i className="fa-solid fa-ellipsis" /></button>
                        <ul className="dropdown-menu">
                            <li><a className="dropdown-item d-flex align-items-center clickable" onClick={() => save_post(data.id)}><i
                                className="fa-solid fa-save" /> {t('Save Post')}</a></li>
                            <li><a className="dropdown-item d-flex align-items-center clickable" onClick={() => get_post_report(data.id)}><i
                                className="fa-solid fa-eye-slash" /> {t('Report Post')}</a></li>

                            {data.user_id === myArr['id'] ?
                                <li><a className="dropdown-item d-flex align-items-center clickable" onClick={() => postDelete(data.id)}><i
                                    className="fa-solid fa-trash-can" /> {t('Delete')} </a></li>
                                : ''}
                        </ul>
                    </div>
                </div>
                <div className="post-body" onDoubleClick={() => handleDoubleTap(data.id)} style={{ position: 'relative', cursor: 'pointer' }}>
                    {!data.audio_room_id && (
                        <div dir="auto" className="post-text pb-1">
                            <span dangerouslySetInnerHTML={{ __html: renderMarkdown(data.is_shared_post ? data.self_details : showMore ? data.details : data.details?.substring(0, 450), { hideSoleLink: data.url_details != null && data.url_details['image'] != null }) }} />
                            {data.details?.length >= 450 && !showMore &&
                                <a className="clickable" style={{ fontSize: '12px', color: '#0d6efd', paddingLeft: '5px' }} onClick={() => setShowMore(!showMore)}>...{t('See More')}</a>
                            }
                        </div>
                    )}
                    {/* Audio Room / Live Stream Card — gradient distinguishes it from regular posts */}
                    {data.audio_room_id && (
                        <div
                            style={{
                                background: data.audio_room_type === 'video'
                                    ? 'linear-gradient(135deg, #FEE2E2 0%, #FCE7F3 50%, #FDE68A 100%)'
                                    : 'linear-gradient(135deg, #DBEAFE 0%, #E0E7FF 50%, #EDE9FE 100%)',
                                borderRadius: '12px',
                                padding: '20px',
                                margin: '0 0 16px',
                                cursor: 'pointer',
                                position: 'relative',
                                border: data.audio_room_type === 'video' ? '1px solid rgba(225, 29, 72, 0.25)' : '1px solid rgba(139, 92, 246, 0.25)',
                                transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'rgba(139, 92, 246, 0.6)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(139, 92, 246, 0.15)'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(139, 92, 246, 0.25)'; e.currentTarget.style.boxShadow = 'none'; }}
                            onClick={() => {
                                window.location.href = data.audio_room_type === 'video' ? '/live-stream' : '/audio-rooms';
                            }}
                        >
                            {/* Top Row: Mic icon + title/meta + Share */}
                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', marginBottom: '18px' }}>
                                {/* Audio identity tile */}
                                <div style={{
                                    width: '44px', height: '44px', borderRadius: '12px',
                                    background: data.audio_room_type === 'video' ? '#e11d48' : '#000', flexShrink: 0,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}>
                                    <i className={data.audio_room_type === 'video' ? 'fa-solid fa-video' : 'fa-solid fa-microphone-lines'} style={{ color: '#fff', fontSize: '18px' }} />
                                </div>

                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}>
                                        <span style={{ color: '#666', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            {data.audio_room_type === 'video' ? 'Live Stream' : 'Audio Room'}
                                        </span>
                                        {data.audio_room_status !== 'ended' && (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '2px 8px', background: '#EF4444', borderRadius: '10px', boxShadow: '0 2px 6px rgba(239, 68, 68, 0.3)' }}>
                                                <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#fff' }} />
                                                <span style={{ color: '#fff', fontSize: '9px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Live</span>
                                            </div>
                                        )}
                                    </div>
                                    <h3 style={{
                                        color: '#000', fontSize: '18px', fontWeight: 700,
                                        lineHeight: 1.3, margin: 0,
                                        wordBreak: 'break-word',
                                    }}>
                                        {data.details?.replace('🎙️ ', '').replace('🔴 ', '') || 'Live Discussion'}
                                    </h3>
                                </div>

                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        navigator.clipboard.writeText(data.audio_room_type === 'video'
                                            ? `${window.location.origin}/live-stream/join/${data.audio_room_id}`
                                            : `${window.location.origin}/audio-rooms?room=${data.audio_room_id}`);
                                        toast.success('Room link copied!');
                                    }}
                                    style={{
                                        width: '32px', height: '32px', borderRadius: '50%',
                                        background: 'transparent', border: '1px solid #e5e5e5',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: '#000', cursor: 'pointer', transition: 'all 0.2s ease',
                                        flexShrink: 0,
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.background = '#f5f5f5'; e.currentTarget.style.borderColor = '#000'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.borderColor = '#e5e5e5'; }}
                                    title="Share Room link"
                                >
                                    <i className="fa fa-share-alt" style={{ fontSize: '12px' }}></i>
                                </button>
                            </div>

                            {/* Meta: hosted by · listening */}
                            <div style={{
                                display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap',
                                marginBottom: '18px', fontSize: '13px', color: '#666',
                            }}>
                                <span>Hosted by <strong style={{ color: '#000', fontWeight: 600 }}>{data.post_by}</strong></span>
                                {data.audio_room_listener_count > 0 && (
                                    <>
                                        <span style={{ color: '#ccc' }}>·</span>
                                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                                            <i className={data.audio_room_type === 'video' ? 'fa-solid fa-eye' : 'fa-solid fa-headphones'} style={{ fontSize: '11px' }} />
                                            {data.audio_room_listener_count} {data.audio_room_type === 'video' ? 'watching' : 'listening'}
                                        </span>
                                    </>
                                )}
                            </div>

                            {/* Action Button */}
                            {data.audio_room_status === 'ended' && data.audio_room_recording_url ? (
                                <div>
                                    {data.audio_room_type === 'video' ? (
                                        <video controls controlsList="nodownload" onContextMenu={e => e.preventDefault()} style={{ width: '100%', borderRadius: '8px', maxHeight: '360px', background: '#000' }} onClick={e => e.stopPropagation()}>
                                            <source src={`${process.env.REACT_APP_API_URL?.replace('/api', '')}${data.audio_room_recording_url}`} />
                                        </video>
                                    ) : (
                                        <audio controls controlsList="nodownload" onContextMenu={e => e.preventDefault()} style={{ width: '100%', borderRadius: '8px' }} onClick={e => e.stopPropagation()}>
                                            <source src={`${process.env.REACT_APP_API_URL?.replace('/api', '')}${data.audio_room_recording_url}`} />
                                        </audio>
                                    )}
                                    <div style={{ textAlign: 'center', color: '#666', fontSize: '12px', fontWeight: 500, marginTop: '8px' }}>
                                        {data.audio_room_type === 'video' ? 'Stream ended · Recording available' : 'Room ended · Recording available'}
                                    </div>
                                </div>
                            ) : data.audio_room_status === 'ended' ? (
                                <div style={{ width: '100%', background: '#f5f5f5', borderRadius: '8px', padding: '12px', color: '#666', fontSize: '14px', fontWeight: 500, textAlign: 'center' }}>
                                    {data.audio_room_type === 'video' ? 'Stream ended' : 'Room ended'}
                                </div>
                            ) : (
                                <button
                                    style={{
                                        width: '100%', background: data.audio_room_type === 'video' ? '#e11d48' : '#000', border: 'none',
                                        borderRadius: '8px', padding: '14px 20px',
                                        color: '#fff', fontSize: '14px', fontWeight: 600,
                                        cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                                        transition: 'background 0.15s ease, transform 0.1s ease',
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (data.audio_room_type === 'video') {
                                            if (data.audio_room_id && window.__liveStreamJoin) {
                                                window.__liveStreamJoin(data.audio_room_id);
                                            } else {
                                                window.location.href = '/live-stream';
                                            }
                                        } else if (data.audio_room_id && window.__audioRoomJoin) {
                                            window.__audioRoomJoin(data.audio_room_id);
                                        } else {
                                            window.location.href = '/audio-rooms';
                                        }
                                    }}
                                    onMouseDown={e => e.currentTarget.style.transform = 'scale(0.98)'}
                                    onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
                                >
                                    <i className={data.audio_room_type === 'video' ? 'fa fa-play' : 'fa fa-headphones'} style={{ fontSize: '14px' }}></i> {data.audio_room_type === 'video' ? 'Watch live' : 'Start listening'}
                                </button>
                            )}
                        </div>
                    )}
                    {(data.images?.length > 0 || data.videos?.length > 0) && (
                        <MediaCarousel
                            images={data.images || []}
                            videos={data.videos || []}
                            onImageClick={(i) => togglePostViewModalDialog(i)}
                        />
                    )}

                    {/* Double-tap heart overlay */}
                    {doubleTapHeart === data.id && (
                        <div className="double-tap-heart-overlay">
                            <LoveFillIcon className="double-tap-heart" />
                        </div>
                    )}

                    {data.url_details != null && data.url_details['image'] != null ?
                        <>
                            <a href={data.url_details['url']} target="_blank" rel="ugc" className="w-100">
                                {data.url_details['image'] != null ?
                                    <div className="post-image">
                                        <img className="img-fluid w-100" src={data.url_details['image']} alt="image" />
                                    </div>
                                    : ''
                                }


                                <div className="share-link-post">
                                    <div className="share-link-post-content">
                                        {linkHost(data.url_details['url']) && (
                                            <span className="share-link-post-host">{linkHost(data.url_details['url'])}</span>
                                        )}
                                        <h5 className="share-link-post-content-heading">
                                            {data.url_details['title']}
                                        </h5>

                                        <p className="share-link-post-content-disc">
                                            {data.url_details['description']}
                                        </p>
                                    </div>

                                </div>
                            </a>
                        </>
                        : ''
                    }

                    {data.is_shared_post ?
                        <div className={'border-1 shared-post-border'}>
                            <div className="post-header d-flex  align-items-center">
                                <div className="image">
                                    <Link to={`/contact/${data.root_user_id}`}>
                                        <div className="user-picture-container rounded-circle"
                                            style={{ backgroundImage: `url(${data.root_user_image})` }} />
                                    </Link>
                                </div>
                                <div className="info ms-2">
                                    <span className="name">

                                        <Link to={`/contact/${data.root_user_id}`}>{data.root_user_name}
                                            <VerifiedBadge verified={data.root_user_is_verified} />
                                        </Link>
                                    </span>
                                    <span className="small-text"><a href="javascript:void(0)">{data.root_post_time}</a></span>
                                </div>
                            </div>
                            <div dir="auto" className="post-text" dangerouslySetInnerHTML={{ __html: renderMarkdown(data.details) }} />
                        </div>
                        : ""}
                    <ul className="post-meta-wrap d-flex justify-content-between align-items-center">
                        <li className="post-react">
                            {isLiked ?
                                <a className={'clickable'} onClick={() => postUnLike(data.id)}><LoveFillIcon className="me-1" /><span>{t('Loved')}</span></a>
                                :
                                <a className={'clickable'} onClick={() => postLike(data.id)}><LoveIcon className="me-1" /><span>{t('Love')}</span></a>
                            }
                            {likeCount > 0 ? <a className={'clickable ms-1'} onClick={() => love_report(data.id)}><span className="number">{likeCount}</span></a> : ''}
                        </li>
                        <li className="post-comment">
                            <a className={'clickable'} onClick={() => toggleComment(data.id)}><CommentsIcon className="me-1" /><span>{t('Comment')}</span></a>
                            {data.totalComments + set_comment > 0 ? <span className="number ms-1">{data.totalComments + set_comment}</span> : ''}
                        </li>
                        <li className="post-share">
                            <a className={'clickable'} onClick={() => share_post(data.id)}><ShareIcon className="me-1" /><span>{t('Share')}</span></a>
                            {data.totalShares > 0 ? <span className="number ms-1">{data.totalShares}</span> : ''}
                        </li>
                    </ul>


                    {/* Instagram-style: "View all X comments" link */}
                    {!show_comment_box && (data.totalComments + set_comment) > 0 ?
                        <div className="view-all-comments">
                            <a className="clickable" onClick={() => toggleComment(data.id)}>{t('View all')} {data.totalComments + set_comment} {t('comments')}</a>
                        </div>
                        : ''}

                    {show_comment_box && ((last_comments?.length > 0) || (data.last_comments?.length > 0)) ?
                        <div className="comments-section-collapse">
                            <div className="comment-sort-dropdown">
                                <button className="comment-sort-toggle" onClick={() => handleSortChange(data.id, commentSort === 'newest' ? 'relevant' : 'newest')}>
                                    {commentSort === 'newest' ? 'Newest' : 'Most relevant'} ▾
                                </button>
                            </div>
                            {/* .sort((a, b) => (a.id > b.id ? -1 : 1)) */}
                            {(() => {
                                // After sort/pagination an explicit fetch populates last_comments.
                                // On initial open, fall back to data.last_comments from Redux.
                                const displayComments = last_comments?.length > 0 ? last_comments : (data.last_comments || []);
                                return displayComments.slice(0, 10).map((getcomment, i) => (
                                <div key={i}
                                    className={`ig-comment ${is_com_delete && comment_id === getcomment.id ? 'd-none' : ''}`}
                                    id={"comments_" + getcomment.post_id}>
                                    <div className="ig-comment-row">
                                        <div className="ig-comment-avatar">
                                            <Link to={`/contact/${getcomment.comment_user_id}`}>
                                                <div className="user-picture-container rounded-circle"
                                                    style={{ backgroundImage: `url(${getcomment.avatar})` }} />
                                            </Link>
                                        </div>
                                        <div className="ig-comment-body">
                                            <p dir="auto" className={!expandedComments[getcomment.id] && getcomment.comment?.length > 200 ? 'ig-comment-text comment-text-truncated' : 'ig-comment-text'}>
                                                <Link to={`/contact/${getcomment.comment_user_id}`} className="ig-comment-username">{getcomment.comment_by}</Link>
                                                {getcomment.comment_user_id === data.user_id ? <span className="comment-author-badge">{t('Author')}</span> : ''}
                                                {' '}{getcomment.comment}
                                            </p>
                                            {getcomment.comment?.length > 200 ? <span className="comment-read-more" onClick={() => toggleCommentExpand(getcomment.id)}>{expandedComments[getcomment.id] ? t('Show less') : t('Read more')}</span> : ''}
                                            {/* Comment image */}
                                            {getcomment.comment_image && (
                                                <div className="ig-comment-image" onClick={() => setFullscreenImg(getcomment.comment_image)}>
                                                    <img
                                                        src={getcomment.comment_image}
                                                        alt="comment attachment"
                                                        onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
                                                    />
                                                </div>
                                            )}
                                            {/* Meta: time · likes · reply */}
                                            <div className="ig-comment-meta">
                                                <span className="ig-comment-time">{getcomment.comment_time}</span>
                                                {(() => {
                                                    const cl = commentLikes[getcomment.id];
                                                    const liked = cl !== undefined ? cl.liked : !!getcomment.is_like;
                                                    const count = cl !== undefined ? cl.count : (getcomment.total_likes || 0);
                                                    return count > 0 ? <span className="ig-comment-likes">{count} {t('Likes')}</span> : null;
                                                })()}
                                                <span className="ig-comment-reply clickable" onClick={() => toggleReply(getcomment.id)}>{t('Reply')}</span>
                                                {getcomment.comment_reply?.length > 0 ? <span className="ig-comment-reply clickable" onClick={() => toggleReply(getcomment.id)}>— {t('View')} {getcomment.comment_reply?.length} {t('replies')}</span> : ''}
                                            </div>
                                        </div>
                                        {/* Right column: ⋯ options (if deletable) + ♡ heart */}
                                        <div className="ig-comment-right-col">
                                            {getcomment.is_deletable === 1 && (
                                                <div className="dropdown ig-comment-options">
                                                    <button className="ig-comment-options-btn dropdown-toggle" type="button"
                                                        data-bs-toggle="dropdown"
                                                        aria-haspopup="true" aria-expanded="false">
                                                        <i className="fa-solid fa-ellipsis" />
                                                    </button>
                                                    <ul className="dropdown-menu dropdown-menu-end">
                                                        <li><a className="dropdown-item d-flex align-items-center clickable"
                                                            onClick={() => commentsDelete(getcomment.id, data.id)}>
                                                            <i className="fa-solid fa-trash-can me-2" /> {t('Delete')}
                                                        </a></li>
                                                    </ul>
                                                </div>
                                            )}
                                            <div className="ig-comment-heart">
                                                {(() => {
                                                    const cl = commentLikes[getcomment.id];
                                                    const liked = cl !== undefined ? cl.liked : !!getcomment.is_like;
                                                    const count = cl !== undefined ? cl.count : (getcomment.total_likes || 0);
                                                    return (
                                                        <a className="clickable" onClick={() => commentLike(data.id, getcomment.id, liked, count)}>
                                                            {liked ? <LoveFillIcon className="ig-heart-icon liked" /> : <LoveIcon className="ig-heart-icon" />}
                                                        </a>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Reply comments */}
                                    {getcomment.comment_reply?.length > 0 ?
                                        getcomment.comment_reply?.map((reply, ri) => (
                                            <div key={ri} id={`reply${reply.id}`}
                                                className={`ig-comment ig-reply ${p_id_com === getcomment.id && show ? '' : 'd-none'} ${reply_comment_delete && reply_comment_id === reply.id ? 'd-none' : ''}`}>
                                                <div className="ig-comment-row">
                                                    <div className="ig-comment-avatar">
                                                        <Link to={`/contact/${reply.comment_user_id}`}>
                                                            <div className="user-picture-container rounded-circle"
                                                                style={{ backgroundImage: `url(${reply.avatar})` }} />
                                                        </Link>
                                                    </div>
                                                    <div className="ig-comment-body">
                                                        <p dir="auto" className="ig-comment-text">
                                                            <Link to={`/contact/${reply.comment_user_id}`} className="ig-comment-username">{reply.comment_by}</Link>
                                                            {reply.comment_user_id === data.user_id ? <span className="comment-author-badge">{t('Author')}</span> : ''}
                                                            {' '}{reply.comment}
                                                        </p>
                                                        {/* Reply image */}
                                                        {reply.comment_image && (
                                                            <div className="ig-comment-image" onClick={() => setFullscreenImg(reply.comment_image)}>
                                                                <img
                                                                    src={reply.comment_image}
                                                                    alt="reply attachment"
                                                                    onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
                                                                />
                                                            </div>
                                                        )}
                                                        <div className="ig-comment-meta">
                                                            <span className="ig-comment-time">{reply.comment_time}</span>
                                                        </div>
                                                    </div>
                                                    {reply.is_deletable ?
                                                        <div className="ig-comment-heart">
                                                            <div className="dropdown">
                                                                <button className="dropdown-toggle" type="button"
                                                                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                    <i className="fa-solid fa-ellipsis" style={{ fontSize: '12px', color: '#aaa' }} />
                                                                </button>
                                                                <ul className="dropdown-menu">
                                                                    <li><span onClick={() => commentsReplyDelete(reply.post_id, reply.comment_id, reply.id)}
                                                                        className="dropdown-item d-flex align-items-center clickable">
                                                                        <i className="fa-solid fa-trash-can" /> {t('Delete')}
                                                                    </span></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        : ''}
                                                </div>
                                            </div>
                                        ))
                                        : ''}

                                    {/* Reply input */}
                                    <div className={`ig-reply-input ${p_id_com === getcomment.id && show ? '' : 'd-none'}`}>
                                        <div className="comment-input-bar">
                                            <div className="comment-input-avatar">
                                                <div className="user-picture-container rounded-circle"
                                                    style={{ backgroundImage: `url(${localStorage.getItem('profile_img') ?? 'https://via.placeholder.com/50x50.png'})` }} />
                                            </div>
                                            <div className="comment-input-pill-wrap">
                                                {reply_image_preview && (
                                                    <div className="comment-img-preview-container">
                                                        <img src={reply_image_preview} className="comment-img-preview" alt="preview" />
                                                        <button className="comment-img-remove" onClick={() => { setReplyImage(null); setReplyImagePreview(null); }}>×</button>
                                                    </div>
                                                )}
                                                <div className="comment-input-pill">
                                                    <input
                                                        type="text"
                                                        className="comment-pill-input"
                                                        placeholder={`${t('Reply to')} @${getcomment.comment_by}…`}
                                                        value={reply_comment}
                                                        onChange={(e) => setReplyComment(e.target.value)}
                                                        onKeyDown={(e) => handleCommentKeyDown(e, () => handleReplyMessage(data.id, getcomment.id))}
                                                    />
                                                </div>
                                                <div className="comment-input-actions">
                                                    <input ref={replyFileRef} type="file" accept="image/*" style={{ display: 'none' }}
                                                        onChange={(e) => {
                                                            const f = e.target.files[0];
                                                            if (f) { setReplyImage(f); setReplyImagePreview(URL.createObjectURL(f)); }
                                                            e.target.value = '';
                                                        }} />
                                                    <button type="button" className="comment-media-btn" onClick={() => replyFileRef.current?.click()}>
                                                        <i className="fa-regular fa-image" />
                                                    </button>
                                                    <div className="emoji-picker-container">
                                                        <button type="button" className="comment-media-btn" onClick={() => setShowReplyEmojiPicker(!showReplyEmojiPicker)}><i className="fa-regular fa-face-smile" /></button>
                                                        {showReplyEmojiPicker && <div className="emoji-picker-popover">{EMOJI_LIST.map((em, idx) => <span key={idx} onClick={() => insertEmoji(em, 'reply')}>{em}</span>)}</div>}
                                                    </div>
                                                    <button type="button" className="comment-send-btn"
                                                        disabled={!reply_comment?.trim() && !reply_image}
                                                        onClick={() => handleReplyMessage(data.id, getcomment.id)}>
                                                        {isLoading && reply_com_id === getcomment.id
                                                            ? <span className="spinner-border spinner-border-sm" />
                                                            : <i className="fa-solid fa-paper-plane" />}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                ));
                            })()}
                            {next_page_url != null ?
                                <div className="view-comment-text text-center">
                                    <a className={'clickable'} onClick={() => fetchPostCommentNext(data.id)}>View more{is_comment_loading ? (
                                        <span className="spinner-border spinner-border-sm ml-5" role="status" aria-hidden="true"></span>
                                    ) : (
                                        <span></span>
                                    )}</a>
                                </div>
                                : ''}
                        </div>
                        : ''
                    }
                </div>

                {/* Fullscreen image lightbox */}
                {fullscreenImg && (
                    <div className="comment-img-fullscreen" onClick={() => setFullscreenImg(null)}>
                        <img src={fullscreenImg} alt="full" />
                    </div>
                )}

                {/* Comment input — compact pill bar */}
                {show_comment_box && (
                    <div className="comment-input-bar comment-input-bar-main">
                        <div className="comment-input-avatar">
                            <div className="user-picture-container rounded-circle"
                                style={{ backgroundImage: `url(${localStorage.getItem('profile_img') ?? 'https://via.placeholder.com/50x50.png'})` }} />
                        </div>
                        <div className="comment-input-pill-wrap">
                            {comment_image_preview && (
                                <div className="comment-img-preview-container">
                                    <img src={comment_image_preview} className="comment-img-preview" alt="preview" />
                                    <button className="comment-img-remove" onClick={() => { setCommentImage(null); setCommentImagePreview(null); }}>×</button>
                                </div>
                            )}
                            <div className="comment-input-pill">
                                <input
                                    ref={commentInputRef}
                                    type="text"
                                    className="comment-pill-input"
                                    placeholder={t('Post your comments…')}
                                    value={write_comment}
                                    onChange={(e) => setWriteComment(e.target.value)}
                                    onKeyDown={(e) => handleCommentKeyDown(e, () => submit_comment(data.id))}
                                />
                            </div>
                            <div className="comment-input-actions">
                                <input ref={commentFileRef} type="file" accept="image/*" style={{ display: 'none' }}
                                    onChange={(e) => {
                                        const f = e.target.files[0];
                                        if (f) { setCommentImage(f); setCommentImagePreview(URL.createObjectURL(f)); }
                                        e.target.value = '';
                                    }} />
                                <button type="button" className="comment-media-btn" onClick={() => commentFileRef.current?.click()}>
                                    <i className="fa-regular fa-image" />
                                </button>
                                <div className="emoji-picker-container">
                                    <button type="button" className="comment-media-btn" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                                        <i className="fa-regular fa-face-smile" />
                                    </button>
                                    {showEmojiPicker && <div className="emoji-picker-popover">{EMOJI_LIST.map((em, idx) => <span key={idx} onClick={() => insertEmoji(em, 'comment')}>{em}</span>)}</div>}
                                </div>
                                <button type="button" className="comment-send-btn"
                                    disabled={!write_comment?.trim() && !comment_image}
                                    onClick={() => submit_comment(data.id)}>
                                    {isLoading ? <span className="spinner-border spinner-border-sm" /> : <i className="fa-solid fa-paper-plane" />}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div >

            <Modal
                isOpen={modalDialog}
                size=""
                toggle={toggleModal}
            >
                <ModalHeader>
                    {t('Report')}
                </ModalHeader>
                <ModalBody>
                    <div className="form-group">
                        <label className="form-label">{t('Category')}</label>
                        <select onChange={(e) => setCategoryId(e.target.value)} className="form-control" id="category" name="category_id">{optionItems}</select>
                    </div>
                    <div className="form-group mt-2">
                        <label className="form-label">{t('Your Message')}</label>
                        <textarea onChange={(e) => setReportNote(e.target.value)} className="form-control" id="note" name="report_note" placeholder={t('Write Your Message')}></textarea>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button onClick={() => send_report(data.id)} className="btn btn-primary" >{t('Submit')} {isLoading ? (
                        <span
                            className="spinner-border spinner-border-sm ml-5"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    ) : (
                        <span></span>
                    )}</button>
                    <button className="btn" onClick={toggleModal}>{t('Cancel')}</button>
                </ModalFooter>
            </Modal>

            <PostLoveModal
                show={modalDialogLoved}
                size=""
                onHide={toggleModalLoved}
            >
                <PostLoveModal.Header closeButton>
                    <div className="post-meta-react-count-love">
                        <a href="javascript:void(0)">
                            <i className="fa-solid fa-heart"></i>
                            <span className="number">{data.totalLikes}</span>
                        </a>
                    </div>

                </PostLoveModal.Header>

                <PostLoveModal.Body className={`custom-scroll pt-2`}>
                    <div className="recent-chat">
                        <ul className="list-group list-group-flush">
                            {post_loved?.map((user, index) => (
                                <UserList user={user} />
                            ))
                            }

                        </ul>
                    </div>
                </PostLoveModal.Body>
            </PostLoveModal>

            <PostShareModal post_data={data} isModalVisible={post_modalDialog} handleShowB={() => setPostShareModalDialog(false)} postId={postId} />
            {/* <PostView data={data} isModalVisible={postView_modalDialog} handleShowB={() => setPostViewModalDialog(false)} imageIndex={image_index} /> */}
        </Fragment >
    )
}